import { AppStateFailure, IStateSlice } from '@symphony-solo/shared/common-state/src';
import { CashlessPayment, CashlessResponse } from '../models';

export class PursesState implements IStateSlice {
  public isLoading: boolean;
  public failures: AppStateFailure;
  public purses: any;
  public purseTopupOption: Object;
  public cashlessPayment: CashlessPayment;
  public cashlessResponse: CashlessResponse;
  public selectedPurseID: number;

  constructor() {
    this.isLoading = false;
    this.failures = null;
    this.purses = null;
    this.purseTopupOption = null;
    this.cashlessPayment = null;
    this.cashlessResponse = null;
    this.selectedPurseID = null;
  }
}
